import { forwardRef, type InputHTMLAttributes } from 'react'
import { cn } from '../lib/cn'

export type InputProps = InputHTMLAttributes<HTMLInputElement>

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ className, type = 'text', ...props }, ref) => (
    <input
      ref={ref}
      type={type}
      className={cn(
        'flex h-10 w-full rounded-md border border-border bg-bg-alt px-3 py-2 text-sm text-fg',
        'placeholder:text-dim shadow-sm transition-colors',
        'focus-visible:outline-none focus-visible:border-secondary focus-visible:ring-[3px] focus-visible:ring-ring',
        'disabled:cursor-not-allowed disabled:opacity-50',
        'aria-[invalid=true]:border-danger aria-[invalid=true]:ring-danger/40',
        'file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-fg',
        className,
      )}
      {...props}
    />
  ),
)
Input.displayName = 'Input'
